module.exports = __webpack_public_path__ + "img/chanpintopimg.a962744a.png";